import { api } from './client';

export type ExportTaskStatus = 'queued' | 'processing' | 'ready' | 'failed';

export interface ExportColumn {
  key: string;
  label: string;
}

export interface ExportTask {
  id: string;
  brand_id: string;
  site_id?: string;
  report_key: string;
  title: string;
  file_name: string;
  status: ExportTaskStatus;
  file_url?: string;
  content_type?: string;
  error?: string;
  created_at: string;
  started_at?: string;
  completed_at?: string;
  downloaded_at?: string;
}

export interface CreateExportTaskPayload {
  report_key: string;
  title: string;
  file_name: string;
  brand_id: string;
  site_id?: string;
  params: Record<string, unknown>;
  columns?: ExportColumn[];
}

interface ApiEnvelope<T> {
  code: number;
  message: string;
  data: T;
}

export const exportTasksApi = {
  create: (payload: CreateExportTaskPayload) =>
    api.post<ApiEnvelope<ExportTask>>('/exports', payload),
  list: (brandId?: string) =>
    api.get<ApiEnvelope<ExportTask[]>>('/exports', { params: brandId ? { brand_id: brandId } : undefined }),
  download: (id: string) =>
    api.get<ApiEnvelope<{ url: string }>>(`/exports/${id}/download`),
  remove: (id: string) =>
    api.delete<ApiEnvelope<{ deleted: boolean }>>(`/exports/${id}`),
};

